<script>
import TooltipComponent from './Tooltip.vue'

let uuid = 0

// Says why the button inside is disabled when it is tapped or reached by keyboard. A disabled button takes
// neither taps nor focus, so the wrapper does.
export default {
    // state
    data () {
        return {
            isShown: false,
            reasonId: 'vca_vue_disabled_tip_reason_' + uuid++,
        }
    },
    props: {
        // whether the reason applies; while it does, taps on the button reach the wrapper
        isActive: Boolean,
        // Tooltip's props
        tooltip: Object,
        // ms the tip stays up, as long as a refused date's tip
        duration: {
            default: 3000,
            type: Number,
        },
    },
    methods: {
        show () {
            if (!this.isActive) return
            this.isShown = true
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => { this.isShown = false }, this.duration)
        },
        hide () {
            clearTimeout(this.timeout)
            this.isShown = false
        },
    },
    watch: {
        isActive (isActive) {
            if (!isActive) this.isShown = false
        },
    },
    // lifecycle
    unmounted () {
        clearTimeout(this.timeout)
    },
    // misc.
    components: {
        Tooltip: TooltipComponent,
    },
}
</script>

<template>
    <span
        class="tw:relative tw:flex"
        v-bind:class="{ 'tw:[&>button]:pointer-events-none': isActive }"
        v-bind:tabindex="isActive ? 0 : undefined"
        v-bind:aria-describedby="isActive ? reasonId : undefined"
        v-on:click="show"
        v-on:focus="show"
        v-on:blur="hide"
    >
        <slot></slot>
        <!-- the tip is visual only; screen readers get the same reason as the wrapper's description -->
        <span hidden v-bind:id="reasonId" v-if="isActive" v-text="tooltip.text"></span>
        <Tooltip aria-hidden="true" v-if="isShown" v-bind="tooltip"/>
    </span>
</template>
